import React, { useContext, useEffect, useState } from "react";
import {
    getRawMaterials,
    deleteRawMaterials,
    updateRawMaterials,
    createRawMaterials,
    getUnits
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { isReadonlyRoute, NaviGate } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { useLocation } from "react-router-dom"
import { EditRawMaterials } from "./rform";

const RawMaterials = () => {
    const { showLoader, hideLoader, shopItem, warehouse } = useContext(WarehouseContext);
    const { pathname } = useLocation();
    const readonly = isReadonlyRoute(pathname);

    const [rawmaterials, setRawmaterials] = useState([]);
    const [selectedRaw, setSelectedRaw] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [addOrEdit, setAddOrEdit] = useState(true);

    const [deleteID, setDeleteID] = useState("");
    const [deletemodel, showDeletemodel] = useState(false);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const rolesPerPage = 10;
    const [unitsList, setUnitsList] = useState([]);

    useEffect(() => {
        fetchRawmaterials();
        fetchUnitsList();
    }, []);

    const fetchUnitsList = async () => {
        try {
            const response = await getUnits();
            if (response.data && response.data.data) {
                setUnitsList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching units:", error);
        }
    };

    const getUnitName = (unitId) => {
        if (!unitId) return "";
        const found = unitsList.find(u => String(u.id) === String(unitId));
        if (found) return found.title;
        if (String(unitId) === "1") return "kg";
        if (String(unitId) === "2") return "gram";
        return unitId;
    };

    const handledeletemodel = (ID) => {
        showDeletemodel(true);
        setDeleteID(ID);
    };

    const fetchRawmaterials = async (page = 1, text = "") => {
        showLoader();
        try {
            const response = await getRawMaterials(shopItem.id);
            if (response.data && response.data.data) {
                setRawmaterials(response.data.data);
                setTotalPages(response.data.pagination?.total_pages || 1);
            }
        } catch (error) {
            console.error("Error fetching raw materials:", error);
            toast.error("Failed to fetch raw materials");
        } finally {
            hideLoader();
        }
    };

    const openAddModal = () => {
        setAddOrEdit(true);
        setSelectedRaw(null);
        console.log('clicked')
        setShowEditModal(true);
    };

    const openEditModal = (raw) => {
        setSelectedRaw(raw);
        setAddOrEdit(false);
        console.log('clicked  222')

        setShowEditModal(true);
    };

    const handleDelete = async () => {
        if (!deleteID) {
            toast.error("No raw material selected to delete");
            return;
        }

        try {
            await deleteRawMaterials(deleteID);
            showDeletemodel(false);
            toast.success("Raw material deleted");
            fetchRawmaterials(currentPage);
        } catch (error) {
            console.error("Error deleting raw material:", error);
            toast.error("Error deleting raw material");
        }
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        fetchRawmaterials(pageNumber);
    };

    const handleSearch = async (text) => {
        fetchRawmaterials(1, text);
        setCurrentPage(1);
    };

    const activateRawMaterial = async (value) => {
        showLoader();
        try {
            const payload = {
                ...value,
                status: "active",
            };
            await updateRawMaterials(value?.id, payload);
            fetchRawmaterials(currentPage);
            toast.success("Raw material activated");
        } catch (err) {
            console.error(err);
            toast.error(err.message);
        } finally {
            hideLoader();
        }
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                <NaviGate />
                <div className="mb-0 d-flex justify-content-between align-items-center">
                    <h6
                        className="mb-0 text-uppercase"
                        style={{ fontFamily: "poppins" }}
                    >
                        Raw Materials List
                    </h6>
                    {!readonly && (
                        <button
                            type="button"
                            onClick={() => openAddModal()}
                            className="btn btn-primary mb-0"
                            style={{ fontFamily: "poppins" }}
                        >
                            Add Raw Material
                        </button>
                    )}
                </div>
                <hr className="mt-1" />

                <div className="card">
                    <div className="card-body">
                        <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
                            <div
                                className="d-flex position-relative"
                                style={{ width: "100%" }}
                            >
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Search..."
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                                <img
                                    src="/assets/images/icons/search.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        right: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        height: "18px",
                                        pointerEvents: "none",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                className="table table-striped table-sm table-bordered"
                                style={{ width: "100%", fontFamily: "poppins" }}
                            >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Title</th>
                                        <th>Type</th>
                                        <th>Product Code</th>
                                        <th>Reorder Point</th>
                                        <th>Stocks Available</th>
                                        {/* <th>Status</th> */}
                                        {/* <th>Created By</th> */}
                                        {!readonly && <th>Actions</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rawmaterials.map((raw, index) => (
                                        <tr key={raw.id}>
                                            <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                                            <td>{raw.title}</td>
                                            <td>{raw.type == "1" ? "Packaging material" : "Spices"}</td>
                                            <td>{raw.product_code}</td>
                                            <td>{raw.reorder_point}</td>
                                            <td>{parseFloat(raw.remaining_stock || 0).toFixed(2)} {getUnitName(raw.unit_id)}</td>
                                            {/* <td>{raw.status}</td> */}
                                            {/* <td>{raw.created_by}</td> */}
                                            {!readonly && (
                                                <td>
                                                    <>
                                                        <img
                                                            src="/assets/images/icons/edit.png"
                                                            onClick={() => openEditModal(raw)}
                                                            height="16px"
                                                            alt="Edit"
                                                        />
                                                        &nbsp;&nbsp;&nbsp;
                                                        <img
                                                            src="/assets/images/icons/delete.png"
                                                            onClick={() => handledeletemodel(raw.id)}
                                                            height="16px"
                                                            alt="Delete"
                                                        />
                                                    </>
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {deletemodel && (
                <Deletemodel
                    setShowModal={showDeletemodel}
                    handleDelete={handleDelete}
                />
            )}

            {/* {showEditModal && ( */}
            <EditRawMaterials
                showModal={showEditModal}
                // setShowModal={() => setShowEditModal(false)}
                setShowModal={() => {
                    setShowEditModal(false);
                    setSelectedRaw(null);
                }}
                fetchRawmaterials={() => fetchRawmaterials()}
                selectedRawmaterial={selectedRaw}
                AddorEdit={addOrEdit}
            // setCurrentPage
            />
            {/* // <div className="modal">
                //   <h5>{addOrEdit ? "Add Raw Material" : "Edit Raw Material"}</h5>
                //   <button onClick={() => setShowEditModal(false)}>Close</button>
                // </div> */}
            {/* )} */}
        </div>
    );
};

export default RawMaterials;
